import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { notify } from '../../../toaster';
import { METABASE_API_URL, metabaseApi } from '../api';
import { QUERY_KEY_COLLECTION_ITEMS } from './useGetCollectionItems';

export const useCopyDashboard = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: async ({
      id,
      collectionId,
      name,
    }: {
      id: number;
      collectionId: number;
      name: string;
    }) => {
      return metabaseApi.post(`${METABASE_API_URL}/dashboard/${id}/copy`, {
        collection_id: collectionId,
        name: `Copy of ${name}`,
        is_deep_copy: true,
      });
    },
    onSuccess: () => {
      notify.default({
        title: intl.formatMessage(
          { id: 'features.reporting.duplicateNotification.itemDuplicated' },
          {
            itemType: intl.formatMessage({
              id: 'features.reporting.itemType.dashboard',
            }),
          }
        ),
      });

      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_COLLECTION_ITEMS],
      });
    },
    onError: () => {
      notify.error({
        title: intl.formatMessage(
          {
            id: 'features.reporting.duplicateNotification.itemDuplicationFailed',
          },
          {
            itemType: intl.formatMessage({
              id: 'features.reporting.itemType.dashboard',
            }),
          }
        ),
      });
    },
  });
};
